module.exports = __webpack_public_path__ + "static/img/icon_snb_asscn_attlt_disc.28524a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_asscn_attlt_disc.svg
// module id = m7uh
// module chunks = 10